import styled from "styled-components";

import Button from "./Button.jsx";
import { breakpoints, spacing } from "../../../../theme";

/**
 * Primary section CTA - matches hero "Contact me" sizing.
 * Use for landing-section actions like Contact me, More Projects, View all.
 */
const SectionActionButton = styled(Button)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;

    @media only screen and (min-width: ${breakpoints.tablet}) {
      font-size: 24px;
      padding: ${spacing(5.25)} ${spacing(9.75)};
    }
  }
`;

export default SectionActionButton;
